<!--动环信息-->
<template>
	<div>
		<p class="ringTitle">动环模块</p>
		<p class="ringInfoP">站点数量: <span>{{siteCount}}</span></p>
		<p class="ringInfoP">环境装置数量: <span>{{surroundingsCount}}</span></p>
		<p class="ringInfoP">安防装置数量: <span>{{securityCount}}</span></p>
		<p class="ringInfoP">摄像头数量: <span>{{videoCount}}</span></p>
		<p class="ringInfoP">电气火灾装置数量: <span>{{warningCount}}</span></p>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				siteCount: 0,
				surroundingsCount: 0,
				securityCount: 0,
				videoCount: 0,
				warningCount: 0
			}
		},
		created() {},
		mounted() {
			var axios = require('axios')
			axios({
				url: "/static/中科泛在定制/看板/数据/info.json",
			}).then(respon => {
				var data = JSON.parse(JSON.stringify(respon.data))
				this.siteCount = data.ringInfo.siteCount
				this.surroundingsCount = data.ringInfo.surroundingsCount
				this.securityCount = data.ringInfo.securityCount
				this.videoCount = data.ringInfo.videoCount
				this.warningCount = data.ringInfo.warningCount
			})
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.ringTitle{
		width: 100%;
		color: #00C6FF;
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		margin-top: 15px;
		margin-bottom: 20px;
	}
	.ringInfoP{
		width: 40%;
		padding-left: 10%;
		display: inline-block;
		margin-bottom: 15px;
		color: #80BFEC;
	}
	.ringInfoP>span{
		color: white;
	}
</style>
